import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-note-icon',
  imports: [],
  templateUrl: './note-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './note-icon.component.scss',
})
export class NoteIconComponent {}
